<template>
    <div class="col-lg-4 cart-right">
        <div class="shippingContainer__summary">
            <h4 class="margin_bottom_md font-md font-bold">SUMMARY</h4>
            
            <div class="row">
                <div class="col-4">Subtotal:</div>
                <div class="col-8 d-flex justify-content-end font-bold">
                    <span class="naira mr-1"></span>{{subTotal | formatNumber }}
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-4">Shipping:</div>
                <div class="col-8 d-flex justify-content-end font-bold">Free</div>
            </div>
            <div class="row mt-3">
                <div class="col-4">Tax:</div>
                <div class="col-8 d-flex justify-content-end font-bold">
                    <span class="naira mr-1"></span>{{tax | formatNumber }}</div>
            </div>
            <div class="divider"></div>
                <div class="row font-bold">
                    <div class="col-4">Total:</div>
                    <div class="col-8 d-flex justify-content-end">
                        <span class="naira mr-1"></span>{{total | formatNumber }}
                    </div>
                </div>
            <div class="divider"></div>
            <!-- <div class="row mt-3">
                <div class="col-8 font-bold">Use coupon code</div>
                <div class="col-4 d-flex justify-content-end font-bold"><a href="#" class="font-md">+</a></div>
            </div> -->

            <div class="margin_top_md">
                <button class="btn btn-secondary col-12" @click="checkout">Checkout</button>
            </div>
        </div>

        <div class="margin_top_md">
            <button class="btn btn-secondary-outline col-12" @click="continueShopping">Continue shopping</button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState('offtaker', ['cart']),
        subTotal() {
            return this.cart.reduce((sum, item) => {
                return sum + (item.crop.agg_kg_price * item.quantity)
            }, 0)
        },
        tax() {
            return this.subTotal * 0.05
        },
        total() {
            return this.subTotal + this.tax
        }
    },
    methods: {
        continueShopping() {
            this.$router.push({
                name: 'offtaker.mycrops'
            })
        },
        checkout() {
            this.$router.push({
                name: "offtaker.shippingdetails",
                params: {
                    id: 'false'
                }
            })
        }
    }
}
</script>

<style>

</style>